/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Intakestillprocessingmany3Inputs */

const en_intakestillprocessingmany3 = /** @type {(inputs: Intakestillprocessingmany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files uploaded · AI is still reading…`)
};

const pt_intakestillprocessingmany3 = /** @type {(inputs: Intakestillprocessingmany3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ficheiros carregados · A IA ainda está a ler…`)
};

/**
* | output |
* | --- |
* | "{count} files uploaded · AI is still reading…" |
*
* @param {Intakestillprocessingmany3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const intakestillprocessingmany3 = /** @type {((inputs: Intakestillprocessingmany3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intakestillprocessingmany3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_intakestillprocessingmany3(inputs)
	return pt_intakestillprocessingmany3(inputs)
});
export { intakestillprocessingmany3 as "intakeStillProcessingMany" }